const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const withVaultDispatch = require("../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../core/hoc/withVaultUpdate");
const AT = require("../core/vault/ActionTypes");
const ToggleItem = require("../office/ToggleItem");
const InfoIcon = require("../office/InfoIcon");
const CopyTable = require("../office/data/CopyTable");
const Editable = require("../office/Editable");
const SelectModal = require("../office/modals/SelectOptionModal");
const {getDisplayedGradeLabel} = require("../../shared/SchoolUtil");

const styles = require("./styles/DefaultSettings.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "DefaultSettings",

		propTypes: {
			className: PT.string,
			settings: PT.object.isRequired,
			schoolID: PT.number,
			classID: PT.number,
			purchaseID: PT.number,
			parentSettings: PT.object,
			isSingleSchool: PT.bool,
			canEdit: PT.bool,
			role: PT.string,

			//Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		vaultEvents: {
			updateClassSettingsSuccess: function() {
				this.setState({selectType: null, status: null});
			},
			updateClassSettingsFail: function(err, moreInfo) {
				this.setState({status: err});
			},
			schoolAccountActionSuccess: function() {
				this.setState({selectType: null, status: null});
			},
			schoolAccountActionFail: function(err, moreInfo) {
				this.setState({status: err});
			},
		},

		getInitialState: function() {
			return {
				selectType: null, // select modal open if not null
				status: null,
			};
		},

		updateSetting(field, selectState) {
			const rawVal = selectState.selected;
			const checked = selectState.checkboxesChecked || [];
			const {schoolID, classID, purchaseID} = this.props;
			const currSettings = this.props.settings;
			let val = rawVal;
			if (
				(field === "grade" || field === "displayedGrade") &&
				currSettings[field] !== parseInt(val)
			) {
				this.props.dispatch({
					type: AT.UPDATE_SCHOOL_ACCOUNTS_SCOPE_REQUEST,
					scope: "class",
					classID,
					vals: field === "grade" ? {gradeID: val} : {displayedGrade: val},
				});
				this.setState({status: "pending"});
			} else if (field !== "grade") {
				if (field === "fixedSets") {
					val = rawVal === "on" ? true : false;
				} else if (field === "lockSettings") {
					val = {
						scheme: rawVal,
						test: _.includes(checked, "test"),
						lab: _.includes(checked, "lab"),
					};
					selectState.customScope &&
						(val.customScope = selectState.customScope);
				}
				if (!_.isEqual(currSettings[field], val)) {
					this.props.dispatch({
						type: AT.UPDATE_SCHOOL_CLASS_SETTINGS_REQUEST,
						settings: {[field]: val},
						schoolID,
						classID,
						// Don't send purchase ID if class or school
						purchaseID: classID || schoolID ? null : purchaseID,
					});
					this.setState({status: "pending"});
				} else {
					this.closeModals();
				}
			}
		},

		onToggleBeastbuilder(value) {
			this.props.dispatch({
				type: AT.SET_CLASS_BEASTBUILDER_LOCK_OVERRIDE_REQUEST,
				classID: this.props.classID,
				value,
			});
		},

		openSelect(type) {
			this.setState({
				selectType: type,
				status: null,
			});
		},

		closeModals() {
			this.setState({selectType: null, status: null});
		},

		render() {
			const {
				settings,
				className,
				parentSettings,
				canEdit,
				role,
				schoolID,
				classID,
				isSingleSchool,
			} = this.props;
			const {lockSettings, grade, displayedGrade, beastLock} = settings;
			const fixedSets = settings.fixedSets ? "on" : "off";
			const {selectType, status} = this.state;

			let scope = "system";
			let scopeChildren = "schools";
			if (classID) {
				scope = "class";
				scopeChildren = "students";
			} else if (schoolID || isSingleSchool) {
				scope = "school";
				scopeChildren = "classes";
			}
			let parentDefault = parentSettings[selectType];
			if (selectType === "fixedSets") {
				parentDefault = parentDefault ? "on" : "off";
			}
			if (scope === "system") {
				parentDefault = null;
			}

			let selectModal = null;
			let initiallyChecked = [];
			let purchaseCustomScope = [];
			if (selectType) {
				const type = selectType === "grade" ? "schoolGrade" : selectType;
				let setting = settings[selectType];
				if (selectType === "lockSettings") {
					initiallyChecked =
						type === "lockSettings"
							? _.filter(_.keys(lockSettings), k => lockSettings[k] === true)
							: [];
					purchaseCustomScope = _.get(setting, "customScope");
					setting = _.get(setting, "scheme");
				}
				if (selectType === "fixedSets") {
					setting = fixedSets;
				}
				const typeCopy = CopyTable.getAccountOptions({
					type,
					parentDefault,
					scope,
					scopeChildren,
					isSingleSchool,
				});
				selectModal = (
					<SelectModal
						title={typeCopy.infoTitle}
						details={typeCopy.description}
						options={typeCopy.options}
						initiallySelected={setting}
						initiallyChecked={initiallyChecked}
						onSelect={selectOptionState => {
							if (purchaseCustomScope?.length) {
								selectOptionState.customScope = purchaseCustomScope;
							}
							this.updateSetting(selectType, selectOptionState);
						}}
						onClose={this.closeModals}
						status={status}
						canMakeTwoRow={true}
					/>
				);
			}

			const makeSettingItem = (type, value) => {
				const copyType = type === "grade" ? "schoolGrade" : type;
				const options = CopyTable.getAccountOptions({
					type: copyType,
					scope,
					scopeChildren,
					isSingleSchool,
				});
				let label;
				if (type === "grade") {
					label = value;
				} else if (type === "displayedGrade") {
					label = getDisplayedGradeLabel(value);
				} else if (type !== "beast") {
					label = options.opts[value].label;
				}
				let title;
				if (type === "grade") title = "BA Level";
				else if (type === "displayedGrade") title = "Grade";
				else title = options.infoTitle;

				let canEditField = canEdit;
				if (type === "displayedGrade") {
					canEditField =
						canEditField && _.includes(["purchaseAdmin", "schoolAdmin"], role);
				}
				const settingEl =
					type === "beast" ? (
						<ToggleItem
							className={styles.settingEditable}
							onToggle={this.onToggleBeastbuilder}
							isOn={value !== "locked"}
						/>
					) : (
						<Editable
							className={styles.settingEditable}
							onClick={() => this.openSelect(type)}
							text={label.toString()}
							editContainerClass={styles.edit}
						/>
					);
				return (
					<div className={styles.item}>
						<div className={styles.itemTop}>
							<InfoIcon
								text={options.info}
								title={options.infoTitle}
								isModal={true}
								className={styles.info}
							/>
							<div className={styles.settingLabel}>{title}</div>
						</div>
						{canEditField ? (
							settingEl
						) : (
							<div className={styles.labelOnly}>{label}</div>
						)}
					</div>
				);
			};

			const levelEl = grade ? makeSettingItem("grade", grade) : null;
			const gradeEl =
				displayedGrade != null
					? makeSettingItem("displayedGrade", displayedGrade)
					: null;
			const beastEl = grade ? makeSettingItem("beast", beastLock) : null;

			return (
				<div className={className || styles.main}>
					{gradeEl}
					{levelEl}
					{makeSettingItem("lockSettings", lockSettings.scheme)}
					{makeSettingItem("fixedSets", fixedSets)}
					{beastEl}
					{selectModal}
				</div>
			);
		},
	})
);
